import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Select } from "antd";
import { ReactComponent as ErrorIcon } from "../../../images/eroor.svg";
import * as action from "../../../redux/actions/actions";
// import PhoneInput from 'react-phone-input-2';
import InputMask from "react-input-mask";
import parsePhoneNumber from 'libphonenumber-js'
import { ReactComponent as BackIcon } from "../../../images/left_arrow.svg";
import * as commonMethod from "../../../commonMethods";
import { store } from "../../../..";

class ChatPanel extends React.Component<any, any> {
  reactTags: any;
  constructor(props: any) {
    super(props);
    this.reactTags = React.createRef();
    this.state = {
      PhoneNumber: "",
      disableCountryCode: true,
      maskValue:null,
      data: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        groupEmail: "",
        showError: "",
        showErrors: false,
        nameErrors: false,
        emailErrors: false,
        loggedInUserCountryCode: "",
        mask: "",
        value: "",
        mandatoryBanner: false,
        sharedEmail:""
      },
    };
  }

  componentDidMount() {
    if (Object.keys(this.props.NewContactData)?.length !== 0) {
      this.setState({ data: { ...this.state.data, phoneNumber: this.props.NewContactData.Participants[0].SfBPhoneNumber.PhoneNumber, groupEmail: this.props.NewContactData.CreatorEmail } });
      var parsePhone = parsePhoneNumber(this.props.NewContactData?.Participants[0].SfBPhoneNumber.PhoneNumber);
      this.setState({ PhoneNumber: parsePhone?.nationalNumber })
    }
  }

  handleInput = (e: any) => {
    this.setState({ data: { ...this.state.data, firstName: e.target.value }, mandatoryBanner: false, });
    var isNamevalid = e.target.value;
    if (isNamevalid === "") {
      this.setState({ nameErrors: true });
    } else {
      this.setState({ nameErrors: false });
    }
  };
  handelFocus=()=>{
    this.setState({maskValue:null});
  }
  validatePhoneNumber =(e:any)=>{
    var phoneNumber = e.target.value;
    if (phoneNumber?.length === 12){
     if (phoneNumber?.startsWith("+1")){
      this.maskValue(e,phoneNumber); 
      }
    }
    if (phoneNumber?.length === 10){
      if (phoneNumber?.startsWith("+61")){
         this.maskValue(e,phoneNumber); 
        }
        if (phoneNumber?.startsWith("+44")){
          this.maskValue(e,phoneNumber);
          }
     }
    this.setState({PhoneNumber:phoneNumber})
  //   let isnum =/^\d+$/.test(phoneNumber);
  //   if(isnum !== true){
  //     this.setState({PhoneNumber:phoneNumber});
  //     return phoneNumber;
  // }
   const JSONMappingData = '{"93":"AF","358":"AX","355":"AL","213":"DZ","1684":"AS","376":"AD","244":"AO","1264":"AI","1268":"AG","54":"AR","374":"AM","297":"AW","61":"AU","43":"AT","994":"AZ","1242":"BS","973":"BH","880":"BD","1246":"BB","375":"BY","32":"BE","501":"BZ","229":"BJ","1441":"BM","975":"BT","591":"BO","5997":"BQ","387":"BA","267":"BW","55":"BR","246":"IO","1284":"VG","673":"BN","359":"BG","226":"BF","257":"BI","855":"KH","237":"CM","1":"CA","238":"CV","1345":"KY","236":"CF","235":"TD","56":"CL","86":"CN","61":"CX","61":"CC","57":"CO","269":"KM","242":"CG","243":"CD","682":"CK","506":"CR","385":"HR","53":"CU","599":"CW","357":"CY","420":"CZ","45":"DK","253":"DJ","1767":"DM","1809":"DO","593":"EC","20":"EG","503":"SV","240":"GQ","291":"ER","372":"EE","251":"ET","500":"FK","298":"FO","679":"FJ","358":"FI","33":"FR","594":"GF","689":"PF","241":"GA","220":"GM","995":"GE","49":"DE","233":"GH","350":"GI","30":"GR","299":"GL","1473":"GD","590":"GP","1671":"GU","502":"GT","44":"GG","224":"GN","245":"GW","592":"GY","509":"HT","379":"VA","504":"HN","852":"HK","36":"HU","354":"IS","91":"IN","62":"ID","225":"CI","98":"IR","964":"IQ","353":"IE","44":"IM","972":"IL","39":"IT","1876":"JM","81":"JP","44":"JE","962":"JO","76":"KZ","254":"KE","686":"KI","965":"KW","996":"KG","856":"LA","371":"LV","961":"LB","266":"LS","231":"LR","218":"LY","423":"LI","370":"LT","352":"LU","853":"MO","389":"MK","261":"MG","265":"MW","60":"MY","960":"MV","223":"ML","356":"MT","692":"MH","596":"MQ","222":"MR","230":"MU","262":"YT","52":"MX","691":"FM","373":"MD","377":"MC","976":"MN","382":"ME","1664":"MS","212":"MA","258":"MZ","95":"MM","264":"NA","674":"NR","977":"NP","31":"NL","687":"NC","64":"NZ","505":"NI","227":"NE","234":"NG","683":"NU","672":"NF","850":"KP","1670":"MP","47":"NO","968":"OM","92":"PK","680":"PW","970":"PS","507":"PA","675":"PG","595":"PY","51":"PE","63":"PH","64":"PN","48":"PL","351":"PT","1787":"PR","974":"QA","383":"XK","262":"RE","40":"RO","7":"RU","250":"RW","590":"BL","290":"SH","1869":"KN","1758":"LC","590":"MF","508":"PM","1784":"VC","685":"WS","378":"SM","239":"ST","966":"SA","221":"SN","381":"RS","248":"SC","232":"SL","65":"SG","1721":"SX","421":"SK","386":"SI","677":"SB","252":"SO","27":"ZA","500":"GS","82":"KR","211":"SS","34":"ES","94":"LK","249":"SD","597":"SR","4779":"SJ","268":"SZ","46":"SE","41":"CH","963":"SY","886":"TW","992":"TJ","255":"TZ","66":"TH","670":"TL","228":"TG","690":"TK","676":"TO","1868":"TT","216":"TN","90":"TR","993":"TM","1649":"TC","688":"TV","256":"UG","380":"UA","971":"AE","44":"GB","1":"US","598":"UY","998":"UZ","678":"VU","58":"VE","84":"VN","681":"WF","212":"EH","967":"YE","260":"ZM","263":"ZW"}';
    const mappingData = JSON.parse(JSONMappingData);
    const countryCode = mappingData[this.props.loggedInUserDefaultCountryCode];
    const phoneNumber1 = parsePhoneNumber(phoneNumber, countryCode);
    if (phoneNumber1) {
      this.setState({PhoneNumber: phoneNumber1.number})
      if (phoneNumber1.isValid() === true) {
        this.setState({
          data: {
            ...this.state.data,phoneNumber: phoneNumber1.number
          },  
        });
        this.maskValue(e,this.state.PhoneNumber); 
        return phoneNumber1.format("E.164");
      } else {
        this.setState({PhoneNumber:phoneNumber})
        return phoneNumber;
      }
    }
    else{
      this.setState({PhoneNumber: phoneNumber})
    }
  }
  validEmail = (e: any) => {
    var emailChecker = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var emailtest = e.target.value;
    var validateEmail = emailChecker.test(emailtest);
    this.setState({ data: { ...this.state.data, email: e.target.value } });
    if (!validateEmail && e.target.value !== "") {
      this.setState({ emailErrors: true });
    } else {
      this.setState({ emailErrors: false });
    }
  };
  saveContact = (e: any) => {
    
    this.props.contactFromAddContact(false)
    var isNamevalid = this.state.data.firstName ? this.state.data.firstName : "";
    if (this.state.data.firstName === "") {
      this.setState({ nameErrors: true });
    } else {
      this.setState({ nameErrors: false });
    }
    var numberToBeSavedInDatabase = "";
    if (this.state.data.Email === "") {
      this.setState({ errorEmail: true });
    } else {
      this.setState({ errorEmail: false });
    }
    var isvalid = this.state.data.phoneNumber ? this.state.data.phoneNumber : "";
    if (isvalid === "") {
      e.preventDefault();
      this.setState({ showError: "Please enter a valid phone number", showErrors: true });
      return;
    } else {
      numberToBeSavedInDatabase = this.state.data.phoneNumber;
      this.setState({ showErrors: false });
      this.setState({ data: { ...this.state.data, phoneNumber: numberToBeSavedInDatabase } });
    }
    if (isNamevalid && isvalid !== "" === true && !this.state.emailErrors && this.state.data.firstName !== "") {
      this.setState({ showErrors: false });
      e.preventDefault();
      var savedFrom = Object.keys(this.props.NewContactData)?.length !== 0 ? this.props.NewContactData.Participants[0].Id : "AddContactForm"; 
      setTimeout(() => { this.props.saveYakChatContact({ ...this.state.data, groupEmail: this.state.sharedEmail || "" }, savedFrom); }, 700);
     
    }
  };
  maskValue=( e:any,value:any)=>{
    if(this.props.loggedInUserDefaultCountryCode === 1){
      this.setState({maskValue:("+9 (999) 999-9999")});
      
    }else if(this.props.loggedInUserDefaultCountryCode === 44){
        this.setState({maskValue:("+99 09999 999999")});
       
    }else if(this.props.loggedInUserDefaultCountryCode === 61){
        this.setState({maskValue:("+99 09 9999 9999")});
    }
     if(this.state.PhoneNumber?.startsWith("+1")){
      this.setState({maskValue:("+9 (999) 999-9999")});
     }
  }
  handleChange = (selectedItems: any) => {
    this.setState({ sharedInboxChange: true })
    let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
          this.setState({sharedEmail: selectedItems });
          var savedEmail =  this.props.yakChatGroupData.find((c:any) => {if (c.InboxId === selectedItems[0]) {return (c.Name)}});
          if(savedEmail===undefined)
         { this.setState({sharedEmail:""})}
          else
          {this.setState({sharedEmail:savedEmail.Name})}
        }
        else
        {
          this.setState({sharedEmail: selectedItems });
          var savedEmail =this.props.yakChatGroupData.find((c:any) => {if (c.UserName === selectedItems[0]) {return (c.Email)}})
          this.setState({sharedEmail:savedEmail.Email})
        }
  };

  render() {
    let companyVersion=store.getState().reduxReducer.companyVersion;
    let tagSuggestions;
      if(companyVersion===2)
        {
     tagSuggestions = this.props.yakChatGroupData && this.props.yakChatGroupData.map((i: any, x: number) => {
      return { label: i?.Name, value: i?.InboxId };
      
    });
  }
  else
  {
    
     tagSuggestions = this.props.yakChatGroupData && this.props.yakChatGroupData.map((i: any, x: number) => {
      return { label: i?.UserName, value: i?.UserName };
      
    });
  }
    return (
      <div className="right_Sec" id="right_Sec_main">
        <div className="top_row mpbilebar">
        <BackIcon id="newMessage-backArrow" className="blk_icon" onClick={() => {
                  commonMethod.hideLeftSection();    
         }} />
          <div className="top_left">
            <h3>New Contact</h3>
          </div>
        </div>
        <div className="chat_or_info">
          <div className="chat_sec">
            <div style={{ textAlign: "left" }} >
              <div className="chat_bx">
                <div className="cntct_frm">
                  <div className="mb-3">
                    <label className="form-label">First name *</label>
                    <input
                      maxLength={50}
                      value={this.state.data.firstName}
                      onChange={this.handleInput}
                      type="text"
                      className={this.state.nameErrors ? "form-control-error form-control" : "form-control"}
                      placeholder="First name"
                    />
                    {this.state.nameErrors ? (
                      <span className="error-div">
                        <ErrorIcon className="error-icon" />{" "}
                        <span className="error-span">
                          "Please enter valid firstName"
                        </span>
                      </span>
                    ) : ("")}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Last name</label>
                    <input
                      maxLength={50}
                      value={this.state.data.lastName}
                      onChange={(e) => this.setState({ data: { ...this.state.data, lastName: e.target.value } })}
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">PHONE NUMBER *</label>
                    <InputMask
                     maxLength={18}
                     className={this.state.showErrors ? "form-control-error form-control" : "form-control"}
                     onChange={this.validatePhoneNumber}
                     onCut={() =>{
                     this.setState({maskValue:"",PhoneNumber:"",});
                     this.setState({
                     data: {
                          ...this.state.data,phoneNumber:""   },  });
                     }}
                    onFocus={()=>this.setState({ maskValue: null })}
                     onPaste={this.validatePhoneNumber}
                     mask={this.state.maskValue}
                     placeholder={"Phone Number"}
                     value={this.state.PhoneNumber}
                     onKeyDown={(event: any) => {
                      if (event.keyCode === 8 || event.keyCode === 46) {
                        this.setState({ maskValue: null })
                      }
                    }}
                    />
                    {
                      this.state.showErrors ? (
                        <span className="error-div">
                          <ErrorIcon className="error-icon" />{" "}
                          <span className="error-span">
                            {this.state.showError}
                          </span>
                        </span>
                      ) : ("")
                    }
                  </div>
                  <div className="mb-3">
                    <label className="form-label">E-MAIL ADDRESS </label>
                    <input
                      value={this.state.data.email}
                      onChange={this.validEmail}
                      type="text"
                      className={this.state.emailErrors ? "form-control-error form-control" : "form-control"}
                      placeholder="E-mail Address"
                    />
                    {this.state.emailErrors ? (
                      <span className="error-div">
                        <ErrorIcon className="error-icon" />{" "}
                        <span className="error-span">
                          Please Enter a Valid Email
                        </span>
                      </span>
                    ) : ("")}
                  </div>
                  {this.props.ServicePlanId === 1 || this.props.ServicePlanId === 3 ? "" :
                    (
                      <div className="mb-3">
                        <label className="form-label">SHARED WITH</label>
                        {tagSuggestions && (
                          <Select
                            className="sharedwith-dropdown"
                            mode="multiple"
                            placeholder="Start typing inbox name..."
                            maxTagPlaceholder="Start typing inbox name..."
                            value={this.state.selectedItems}
                            onChange={this.handleChange}
                            filterOption={(v, option) => {
                              v = v.toLowerCase();
                              const a: any = option;
                              return (a?.label.toLowerCase().includes(v) || a?.value.toLowerCase().includes(v));
                            }}
                            style={{ width: "100%" }}
                            options={tagSuggestions}
                          ></Select>
                        )}
                      </div>)}
                </div>
              </div>
              <div className="msg_txtbx justify-content-end align-items-center">
                <button
                  className="btn cstm_btn blk_btn"
                  
                  onClick={() => { 
                    this.props.setTabOpened(""); this.setState({ nameErrors: false, showErrors: false }); }}
                >
                  Cancel
                </button>
                <div className="dropdown">
                  <div className="btn_wid_drp active save_buTn">
                    <input
                      value="Save Contact"
                      type="submit"
                      className="btn cstm_btn ylo_btn2"
                      onClick={ this.saveContact}
                    />
                    {this.state.nameErrors || this.state.showErrors
                      ? (this.props.setAlertData({
                        className: "danger", text: " Complete mandatory information and save",
                      }), setTimeout(() => { this.props.setAlertData(null); }, 1500))
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props: any) => {
  console.log(props.reduxReducer)
  return {
    testData: props.reduxReducer.testName,
    tabOpened: props.reduxReducer.tabOpened,
    yakChatGroupData: props.reduxReducer.setSharedEmails,
    NewContactData: props.reduxReducer.NewContactData,
    loggedInUserDefaultCountryCode: props.reduxReducer.loggedInUser.DefaultCountryCode,
    ServicePlanId: props.reduxReducer.ServicePlanId,
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch<{}, null, any>, props: any) => {
  return {
    saveYakChatContact: async (contact: any, savedFrom: any) => {
      let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
        {
      dispatch<any>(action.saveYakChatContact_V2(contact, savedFrom));
        }
        else
        {
          dispatch<any>(action.saveYakChatContact(contact, savedFrom));
        }
    },
    setTabOpened: (tab: string) => {
      dispatch<any>(action.setTabOpened(tab));
    },
    setAlertData: (data: any) => {
      dispatch<any>(action.setAlertData(data));
    },
    contactFromAddContact:(value:any) =>{
      dispatch<any>(action.contactFromAddContact(value));
    },
    contactFromNewContact:(value:any) =>{
      dispatch<any>(action.contactFromNewContact(value));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChatPanel);
